import GBBVRSessionIcon from 'assets/media/icons/GBBVRSession.svg';
import DataEditorIcon from 'assets/media/icons/DataEditor.svg';
import RolesIcon from 'assets/media/icons/Roles.svg';
import UserPermissionIcon from 'assets/media/icons/UserPermission.svg';
import ConfigurationIcon from 'assets/media/icons/Configuration.svg';
import VariantsIcon from 'assets/media/icons/Variants.svg';
import ArchiveIcon from 'assets/media/icons/Archive.svg';
import ViewContentIcon from 'assets/media/icons/viewContent.svg';

import Home from 'modules/home/pages/home/Home';
import DataEditor from 'modules/data-editor/pages/data-editor/DataEditor';
import MasterData from 'modules/master-data/pages/master-data/MasterData';
import Variants from 'modules/master-data/pages/variants/Variants';
import ArchiveList from 'modules/archive/pages/archive-list/ArchiveList';
import TrendingData from 'modules/configuration/pages/trending-data/TrendingData';
import WhatsNew from 'modules/configuration/pages/whats-new/WhatsNew';
import KeyIndicator from 'modules/configuration/pages/key-indicator/KeyIndicator';
import FrequentlyUsed from 'modules/configuration/pages/frequently-used/FrequentlyUsed';
import StaticIndicator from 'modules/configuration/pages/static-indicator/StaticIndicator';
import GeographyOverview from 'modules/configuration/pages/geography-overview/GeographyOverview';
import VideoLink from 'modules/configuration/pages/video-links/VideoLink';
import UploadListPage from 'modules/configuration/pages/upload-list-page/UploadListPage';
import IndicatorSources from 'modules/configuration/pages/indicator-sources/IndicatorSources';
import SyncHistory from 'modules/sync-history/pages/sync-history/SyncHistory';
import {
    ComponentRegistry,
    ComponentSpecificRouteRegistry
} from 'common/models/roles-and-access/roleAccess.model';
import CompanyFootprint from 'modules/data-management/pages/company-footprint/CompanyFootprint';
import AdminRoleManagement from 'modules/admin-roles-management/pages/role-management/AdminRoleManagement';
import UserPermissions from 'modules/user-management/pages/user-permissions/UserPermissions';
import AddEditVideoLinks from 'common/components/custom/add-video-link/AddEditVideoLinks';
import AddWhatsNew from 'common/components/custom/add-whats-new/AddWhatsNew';

export const MAIN_ROUTES = {
    DEFAULT: '/',
    WILD: '*',
    HOME: '/home',
    DATA_EDITOR: '/data-editor',
    CONCURRENCY: '/concurrent-user',
    MASTER_DATA: '/variants/master-data',
    VARIANTS: '/variants',
    WHATS_NEW_CREATE_NEW: '/configuration/whats-new/create-new',
    VIDEO_LINKS_CREATE_NEW: '/configuration/video-links/create-new',
    CONFIGURATION_WHATS_NEW: '/configuration/whats-new',
    ARCHIVE: '/archived-items',
    CONFIGURATION_TRENDING_DATA: '/configuration/trending-data',
    CONFIGURATION_KEY_INDICATOR: '/configuration/key-indicator',
    CONFIGURATION_FREQ_USED: '/configuration/frequently-used',
    CONFIGURATION_STATIC_INDICATOR: '/configuration/static-indicator',
    CONFIGURATION_GEOGRAPHY_OVERVIEW: '/configuration/geography-overview',
    CONFIGURATION_VIDEO_LINKS: '/configuration/video-links',
    DATA_MANAGEMENT_INDICATOR_SOURCES: '/data-management/indicator-sources',
    UPLOAD_LIST_PAGE: 'upload-log',
    VARIANT_GBB_PUBLIC: '/variants/gbb-public',
    SYNC_LOGS: '/sync-logs',
    UNAUTHORIZED: '/unauthorized',
    DATA_MANAGEMENT_COMPANY_FOOTPRINT: '/data-management/company-footprint',
    USER_PERMISSION: '/user-permission'
};

export const MENU_ROUTES = [
    // {
    //     label: 'GBB VR Sessions',
    //     path: '/vr-sessions',
    //     icon: GBBVRSessionIcon
    // },
    {
        label: 'Data Editor',
        path: '/data-editor',
        icon: DataEditorIcon
    },
    {
        label: 'Roles',
        path: '/roles',
        icon: RolesIcon
    },
    {
        label: 'User Permission',
        path: '/user-permission',
        icon: UserPermissionIcon
    },
    {
        label: 'Variants',
        path: '/variants',
        icon: VariantsIcon,
        subRoutes: [
            {
                label: 'Master Data',
                path: '/variants/master-data'
            }
            // {
            //     label: 'GBB Public',
            //     path: '/variants/gbb-public'
            // }
            // {
            //     label: 'GBB Subscription',
            //     path: '/variants/gbb-subscription'
            // }
            // {
            //     label: 'GBB Lorem',
            //     path: '/variants/gbb-lorem'
            // }
        ]
    },
    {
        label: 'Archived Items',
        path: '/archived-items',
        icon: ArchiveIcon
    },
    {
        label: 'Upload History',
        path: '/upload-log',
        icon: ViewContentIcon
    },
    {
        label: 'Sync History',
        path: '/sync-logs',
        icon: ViewContentIcon
    },
    {
        label: 'Configuration',
        path: '/configuration',
        icon: ConfigurationIcon,
        subRoutes: [
            {
                label: 'Trending Data',
                path: '/configuration/trending-data'
            },
            {
                label: "What's New",
                path: '/configuration/whats-new'
            },
            {
                label: 'Frequently Used',
                path: '/configuration/frequently-used'
            },
            {
                label: 'Static Indicator',
                path: '/configuration/static-indicator'
            },
            {
                label: 'Geography Overview',
                path: '/configuration/geography-overview'
            },
            {
                label: 'Key Indicator',
                path: '/configuration/key-indicator'
            },
            {
                label: 'Video Links',
                path: '/configuration/video-links'
            }
        ]
    },
    {
        label: 'Data Management',
        path: '/data-management',
        icon: VariantsIcon,
        subRoutes: [
            {
                label: 'EY Company Footprint',
                path: '/data-management/company-footprint'
            },
            {
                label: 'Indicator Sources',
                path: '/data-management/indicator-sources'
            }
        ]
    },
    {
        label: 'Admin Roles Management',
        path: '/admin-roles-management'
    },
    {}
];
/**
 * This is the registry of all the components that are accessible to the user
 * this order will be followed irrespective of api data order
 * if you are adding any new component , please add it here and also in the ROLES_AND_ACCESS_MOCK_DATA
 * in case you want to work on mock data
 * to work on mock data , please follow the steps mentioned in src\common\redux\user\features.service.ts
 */
export const COMPONENT_REGISTRY: ComponentRegistry = {
    // {
    //     label: 'GBB VR Sessions',
    //     path: '/vr-sessions',
    //     icon: GBBVRSessionIcon
    // },
    DATA_EDITOR_UPLOAD: {
        label: 'Data Editor',
        path: '/data-editor',
        icon: DataEditorIcon,
        component: DataEditor
    },
    // {
    //     label: 'Roles',
    //     path: '/roles',
    //     icon: RolesIcon
    // },
    // {
    //     label: 'User Permission',
    //     path: '/user-permission',
    //     icon: UserPermissionIcon
    // },
    VARIANTS: {
        label: 'Variants',
        path: '/variants',
        icon: VariantsIcon,
        component: Variants,
        subRoutes: {
            MASTER_DATA_MANAGEMENT: {
                label: 'Master Data',
                path: '/variants/master-data',
                component: MasterData
            }
            // {
            //     label: 'GBB Public',
            //     path: '/variants/gbb-public'
            // }
            // {
            //     label: 'GBB Subscription',
            //     path: '/variants/gbb-subscription'
            // }
            // {
            //     label: 'GBB Lorem',
            //     path: '/variants/gbb-lorem'
            // }
        }
    },
    ARCHIVE_FUNCTIONALITY_OF_MASTER_DATA: {
        label: 'Archived Items',
        path: '/archived-items',
        icon: ArchiveIcon,
        component: ArchiveList
    },
    UPLOAD_HISTORY: {
        label: 'Upload History',
        path: '/upload-log',
        icon: ViewContentIcon,
        component: UploadListPage
    },
    SYNC_HISTORY: {
        label: 'Sync History',
        path: '/sync-logs',
        icon: ViewContentIcon,
        component: SyncHistory
    },
    CONFIGURATION_GBB_PUBLIC: {
        label: 'Configuration',
        path: '/configuration',
        icon: ConfigurationIcon,
        component: TrendingData,
        subRoutes: {
            TRENDING_DATA: {
                label: 'Trending Data',
                path: '/configuration/trending-data',
                component: TrendingData
            },
            WHATSNEW: {
                label: "What's New",
                path: '/configuration/whats-new',
                component: WhatsNew
            },
            FREQUENTLY_USED: {
                label: 'Frequently Used',
                path: '/configuration/frequently-used',
                component: FrequentlyUsed
            },
            STATIC_INDICATOR: {
                label: 'Static Indicator',
                path: '/configuration/static-indicator',
                component: StaticIndicator
            },
            GEOGRAPHY_OVERVIEW: {
                label: 'Geography Overview',
                path: '/configuration/geography-overview',
                component: GeographyOverview
            },
            KEY_INDICATOR: {
                label: 'Key Indicator',
                path: '/configuration/key-indicator',
                component: KeyIndicator
            },
            'VIDEO_LINK_(BRIGHTCOVE_VIDEO_LINK)': {
                label: 'Video Links',
                path: '/configuration/video-links',
                component: VideoLink
            }
        }
    },
    DATA_MANAGEMENT: {
        label: 'Data Management',
        path: '/data-management',
        icon: VariantsIcon,
        component: IndicatorSources, // temporary remove later
        subRoutes: {
            EY_COMPANY_FOOTPRINT: {
                label: 'EY Company Footprint',
                path: '/company-footprint',
                component: CompanyFootprint
            },
            INDICATOR_SOURCES: {
                label: 'Indicator Sources',
                path: '/configuration/indicator-sources',
                component: IndicatorSources
            }
        }
    },
    ADMIN_ROLE_MANAGEMENT: {
        label: 'Admin Roles Management',
        path: '/admin-roles-management',
        icon: RolesIcon,
        component: AdminRoleManagement,
        subRoutes: {
            ROLE_MANAGEMENT: {
                label: 'Roles Management',
                path: '/admin-roles-management',
                component: AdminRoleManagement
            },
            USER_PERMISSION: {
                label: 'User Permission',
                path: '/user-permission',
                component: UserPermissions
            }
        }
    },
    USER_PERMISSION: {
        label: 'User Permission',
        path: '/user-permission',
        icon: UserPermissionIcon,
        component: UserPermissions
    }
};

/**
 * This is the registry of all the components that are accessible from within the page.
 * Eg: WhatsNew & VideoLink Create New component which is rendered on 'Add New' button click
 * if you are adding any new component , please add it here and also in the ROLES_AND_ACCESS_MOCK_DATA
 */
export const COMPONENT_SPECIFIC_ROUTES: ComponentSpecificRouteRegistry = {
    ADD_EDIT_VIDEO_LINK: {
        label: '',
        path: 'configuration/video-links/create-new',
        component: AddEditVideoLinks,
        featureKey: 'SET_UP_BRIGHTCOVE_VIDEO_LINK'
    },
    ADD_EDIT_WHATSNEW: {
        label: '',
        path: '/configuration/whats-new/create-new',
        component: AddWhatsNew,
        featureKey: 'SET_UP_WHATSNEW'
    }
};
